import {Component, Input, OnInit} from "@angular/core";
import {FormatService} from "../../../services/format.service";
import {NotificationService} from '../../../services/notification.service';

@Component({
    selector: 'app-copy',
    templateUrl: './copy.component.html',
})
export class CopyComponent implements OnInit{

    @Input('text') text: string;
    constructor(
        private notifServ: NotificationService
    ){}

    ngOnInit(){}

    copy(string){
        document.addEventListener('copy', (e: ClipboardEvent) => {
            e.clipboardData.setData('text/plain', string);
            e.preventDefault();
            document.removeEventListener('copy');
        });
        if(document.execCommand('copy')){
            this.notifServ.sendSuccess('Value has been copied to your clipboard')
        }else{
            this.notifServ.sendError('There was an error copying to your clipboard')

        }

    }
}


// WEBPACK FOOTER //
// /Users/moe.dchater/personal/firebase-projects/hosting/src/app/projects/shared/copy/copy.component.ts